import React from "react";
import styles from "./styles.m.css";
import { Icon } from "../../atoms/icon";
import { PropTypes } from "prop-types";

import Cookies from "universal-cookie";
import { GA } from "../../../integrations";

const cookies = new Cookies();

class UtStdFirst extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      readmore: true,
      modalIsOpen: null,
      popup: false,
      orderData: null,
      login: !!cookies.get("vuid"),
      faq: false,
      event: null,
      loader: false,
      showTestimonials: false,
      contentTestimonials: false
    };
  }

  handleClickEvent = () => {
    const { storyUrl } = this.props;
    GA.customEvent("Paywall Click", "paywall-count", storyUrl);
  };

  render() {
    const { count, supportJournalism, storyUrl } = this.props;
    return (
      <div className={styles["standard-paywall"]}>
        <div onClick={this.props.closeThis()} className={styles["close-div"]}>
          <Icon type={"close"} />
        </div>
        <p>
          விகடன் வணக்கம்! நீங்கள் எங்களது பிரீமியம் கட்டுரையை இப்பொழுது படித்து வருகிறீர்கள். உங்களால் இன்னும்{" "}
          <span className={styles["stdpaywall-msg"]}>{count} </span> பிரீமியம் கட்டுரைகளை கட்டணமில்லாமல் இம்மாதம் படிக்க
          முடியும்.
        </p>
        <br />

        {(supportJournalism && (
          <React.Fragment>
            <p>அறத்திற்கான இந்த இதழியல் பணி தொடர உங்கள் ஆதரவு தொடர்ந்து தேவை! </p>
            <p>Subscribe செய்யுங்கள், விகடனுடன் தொடர்ந்து பயணியுங்கள்!</p>
          </React.Fragment>
        )) || <p>தொடர்ந்து எங்களது அனைத்து படைப்புகளையும் சிறந்த வாசிப்பனுபவத்துடன் படிக்க சப்ஸ்கிரைபர் ஆகுங்க..!</p>}

        <a
          href={
            (supportJournalism &&
              "https://store.vikatan.com/support-real-journalism/?utm_source=Support_jour&utm_medium=7free&utm_campaign=Support_jour_7free") ||
            `https://store.vikatan.com/?utm_source=Paywall&utm_medium=5free&utm_campaign=Paywall_5free&redirect_url=${encodeURIComponent(
              storyUrl
            )}`
          }
          onClick={() => {
            this.handleClickEvent();
          }}
          className={styles["btn-auto"]}
        >
          Subscribe Now
        </a>
      </div>
    );
  }
}

UtStdFirst.propTypes = {
  type: PropTypes.string,
  storyId: PropTypes.string,
  storyUrl: PropTypes.string,
  pwtype: PropTypes.string,
  closeThis: PropTypes.func,
  count: PropTypes.number,
  access: PropTypes.object,
  supportJournalism: PropTypes.bool
};

export default UtStdFirst;
